<template>
  <div class="single-precopyright-item">
    <div class="terms">
      <div class="label-wrap">
        <label for="terms-input">Input Label</label>
        <span class="material-icons">help_outline</span>
      </div>
      <a-input
        :maxLength="255"
        placeholder="Terms"
        class="terms-input"
        id="terms-input"
        :value="el.terms"
        @input="emitTerms($event.target.value)"
      />
    </div>
    <div class="link">
      <div class="label-wrap">
        <label for="terms-input">Input Label</label>
        <span class="material-icons">help_outline</span>
      </div>
      <a-input
        :maxLength="255"
        :addon-before="FOOTER_URL_PREFIX"
        default-value="domain.com"
        class="link-input"
        :value="el.domain"
        @input="emitDomain($event.target.value)"
      />
    </div>
    <div class="btn-wrap">
      <a-button
        type="primary"
        class="btn-remove"
        @click="deleteItem"
        :disabled="isLast"
      >
        <span class="material-icons">delete</span>
        Remove
      </a-button>
      <a-button type="primary" class="btn-updown" @click="pushUpItem">
        <span class="material-icons">expand_less</span>
      </a-button>
      <a-button type="primary" class="btn-updown" @click="pushDownItem">
        <span class="material-icons">expand_more</span>
      </a-button>
      <a-button
        type="primary"
        class="btn-updown"
        @click="addNewItem"
        v-if="isLast"
      >
        <i class="material-icons">add</i>
      </a-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    index: {
      type: Number,
    },
    isLast: {
      type: Boolean,
    },
    el: {
      type: Object,
    },
  },
  data(){
    return {
      test:true
    }
  },
  computed: {
    ...mapState(['FOOTER_URL_PREFIX']),
  },
  methods: {
    emitTerms(newVal) {
      this.$emit('termsValue', { id: this.index, terms: newVal })
    },
    emitDomain(newVal) {
      this.$emit('domainValue', { id: this.index, domain: newVal })
    },
    addNewItem() {
      this.$emit('addNewItem')
    },
    deleteItem() {
      this.$emit('removeItem', this.index)
    },
    pushUpItem() {
      this.$emit('pushUpItem', this.index)
    },
    pushDownItem() {
      this.$emit('pushDownItem', this.index)
    },
  },
}
</script>

<style lang="scss" scoped>
.single-precopyright-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: 670px;
  //utility
  input,
  .ant-input,
  .ant-input-group-addon {
    border-radius: 2px !important;
  }
  .label-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 5px 0;
    .material-icons {
      color: #b2bac7;
      font-size: 14px;
      display: inline-block;
      margin: 0 5px;
    }
  }
  //utility ends
  .terms-input {
    width: 150px;
    height: 40px;
    box-sizing: border-box;
    margin: 0 7px 0 0;
  }
  .link-input {
    height: 40px;
  }
  .btn-wrap {
    display: flex;
    align-self: flex-end;
    .btn-remove {
      width: 100px;
      height: 40px;
      background: #d23214;
      border-radius: 2px;
      border: none;
      margin: 0 4px;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      color: #ffffff;
    }
    .btn-updown {
      width: 40px;
      height: 40px;
      background: #f4f5f7;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      margin: 0 4px;
      .material-icons {
        color: #001529;
      }
    }
  }
}
</style>

<style>
body
  > div
  > div
  > div.footer.admin-page
  > div.content-wrap
  > div.pre-copyright-navigation
  > div
  > div.link
  > span
  > span
  > input {
  border-radius: 2px !important;
  width: 255px !important;
  height: 40px !important;
}
</style>
